import React, { useEffect, useState } from "react";
import Modal from "../../../../../ReusableComponents/Modal";
import { updateCompany } from "../../../../../apis/users";
import Loading from "../../../../../ReusableFunctions/Loader";
import Popup from "../../../../../ReusableFunctions/Popup";
import Form from "../../../../../ReusableComponents/Form";
import InputField from "../../../../../ReusableComponents/InputField";
import { Button } from "../../../../../Components/Helper";
import {
  addressValidation,
  selectFieldValidation,
} from "../../../../../utils/inputValidations";
import SelectField from "../../../../../ReusableComponents/SelectField";
import {
  getDistricts,
  getStates,
  getTalukas,
} from "../../../../../apis/locations";
import SelectComponent from "../../../../../ReusableComponents/SelectComponent";
import { getToken } from "../../../../../apis/authentication";

const EditCompanyAdd = ({
  user,
  open,
  onClose,
  onUserUpdate,
  selectedCountry,
  selectedState,
  selectedCity,
}) => {
  const [companyAddress, setcompanyAddress] = useState({
    address: user.dsp.address,
    state: selectedState
      ? { label: selectedState, value: selectedState }
      : undefined,
    city: selectedCity
      ? { label: selectedCity, value: selectedCity }
      : undefined,
    country: selectedCountry
      ? { label: selectedCountry, value: selectedCountry }
      : undefined,
  });
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState({
    state: false,
    country: false,
    city: false,
  });
  const updateCompanyInfo = async (address,country, state, city) => {
    Loading.set(true);
    try {
      await updateCompany({
        ...user.dsp,
        address,
        country:country,
        state: state,
        city: city,
      })
        .then((res) => {
          onUserUpdate({ ...user.dsp, address, state, city,country });
          Loading.set(false);
          Popup.alert(
            "SUCCESS",
            <p>
              Congratulations !<br />
              We are delighted to inform you that your address has been changed
              successfully!
            </p>,
            "SUCCESS",
            () => {}
          );
        })
        .catch((e) => {
          Loading.set(false);
          console.log(e);
          Popup.alert("Profile", e, "ERROR", () => {});
        });
    } catch (e) {
      Loading(false);
      console.log(e);
      Popup.alert(
        "Profile",
        "Something went wrong while updating profile",
        "ERROR",
        () => {}
      );
    }
  };

  const getCountriesFunc = async () => {
    try {
      setLoading((prevLoading) => ({
        ...prevLoading,
        country: true,
      }));

      setStates([]);
      setCities([]);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/dsp/countries`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error(
          `Something went wrong while getting cities ${response.status}`
        );
      }

      let res = await response.json();
      setCountries(res.countries);
    } catch (err) {
      console.log("err", err);
    } finally {
      setLoading((prevLoadingState) => ({
        ...prevLoadingState,
        country: false,
      }));
    }
  };

  const getStatesOfCountry = async (countryId, countryName) => {
    setLoading((prevLoading) => ({
      ...prevLoading,
      state: true,
    }));
    try {
        const url = `${process.env.REACT_APP_API_URL}/dsp/countries/states/${countryId}?countryName=${encodeURIComponent(countryName)}`;
      const response = await fetch(url,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setStates(data?.states || []);
    } catch (err) {
      console.error("Failed to fetch states", err);
    } finally {
      setLoading((prevLoading) => ({
        ...prevLoading,
        state: false,
      }));
    }
  };

  const getCitiesOfState = async (stateCode, stateName) => {
    setLoading((prev) => ({ ...prev, city: true }));
    try {
       const url = `${process.env.REACT_APP_API_URL}/dsp/countries/states/cities/${stateCode}?stateName=${encodeURIComponent(stateName)}`;
      const response = await fetch(url,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setCities(data?.cities || []);
    } catch (err) {
      console.error("Failed to fetch cities", err);
    } finally {
      setLoading((prev) => ({ ...prev, city: false }));
    }
  };

  const initData = async () => {
    await getCountriesFunc();
    await getStatesOfCountry(undefined, selectedCountry);
    await getCitiesOfState(undefined, selectedState);
  };

  useEffect(() => {
    initData();
  }, []);

  return (
    <Modal
      header={"Edit Address"}
      open={open}
      onClose={onClose}
      contentStyle={{ width: "534px", height: "auto" }}
      divider={true}
      headingStyle={{ fontSize: "18px" }}
      iconSize={"18px"}
      headerContainerStyle={{ padding: "20px 40px" }}
    >
      <div style={{ padding: "15px 46px" }}>
        <div className="flex flex-col w-full gap-[1.8rem] mt-1">
          <div className="flex flex-col gap-1">
            <div className="text-[15px] ">Country</div>
            <SelectComponent
              isLoading={loading?.country}
              controlStyle={{
                height: "40px",
                width: "100%",
                borderRadius: "0px",
                border: "1px solid rgba(191, 200, 217, 1)",
                backgroundColor: "rgba(243, 243, 243, 1)",
                color: "hsl(0deg 0% 20% / 64%)",
                fontSize: "12px",
              }}
              isDisabled={loading.country}
              isSearchable={true}
              placeholder={"Select State"}
              menuPlacement={"bottom"}
              list={countries?.map((state) => ({
                value: state.name,
                label: state.name,
              }))}
              value={
                companyAddress?.country || {
                  label: "Select country",
                  value: undefined,
                }
              }
              onChange={(country) => {
                if (country.value && typeof country.value === "string") {
                  getStatesOfCountry(undefined, country.value);
                }
                setcompanyAddress((prevData) => ({
                  ...prevData,
                  country: country,
                  state: undefined,
                  city: undefined,
                }));
              }}
            />
          </div>
          <div className="flex flex-col gap-1">
            <div className="text-[15px] ">State</div>
            <SelectComponent
              isLoading={loading?.state}
              controlStyle={{
                height: "40px",
                width: "100%",
                borderRadius: "0px",
                border: "1px solid rgba(191, 200, 217, 1)",
                backgroundColor: "rgba(243, 243, 243, 1)",
                color: "hsl(0deg 0% 20% / 64%)",
                fontSize: "12px",
              }}
              isDisabled={loading.state}
              isSearchable={true}
              placeholder={"Select State"}
              menuPlacement={"bottom"}
              list={states?.map((state) => ({
                value: state.name,
                label: state.name,
              }))}
              value={
                companyAddress?.state || {
                  label: "Select state",
                  value: undefined,
                }
              }
              onChange={(state) => {
                if (state.value && typeof state.value === "string") {
                  getCitiesOfState(undefined, state?.value);
                }
                setcompanyAddress((prevData) => ({
                  ...prevData,
                  state: state,
                  city: undefined,
                }));
              }}
            />
          </div>
          <div className="flex flex-col gap-1">
            <div className="text-[15px] ">City</div>
            <SelectComponent
              isLoading={loading?.city}
              controlStyle={{
                height: "40px",
                width: "100%",
                borderRadius: "0px",
                border: "1px solid rgba(191, 200, 217, 1)",
                backgroundColor: "rgba(243, 243, 243, 1)",
                color: "hsl(0deg 0% 20% / 64%)",
                fontSize: "12px",
              }}
              isDisabled={loading.city}
              isSearchable={true}
              placeholder={"Select City"}
              menuPlacement={"bottom"}
              list={cities?.map((city) => ({
                value: city?.name,
                label: city?.name,
              }))}
              value={
                companyAddress?.city || {
                  label: "Select city",
                  value: undefined,
                }
              }
              onChange={(city) => {
                setcompanyAddress((prevData) => ({
                  ...prevData,
                  city: city,
                }));
              }}
            />
          </div>
          <div className="flex flex-col gap-1">
            <span className="">Address</span>
            <input
              type="text"
              name="address"
              className="w-full text-[13px] bg-[#F3F3F3] h-[40px]
                    py-1 px-3 outline-none focus:outline-none border 
                    border-solid border-[#BFC8D9] placeholder:text-sm"
              placeholder="Enter full address"
              value={companyAddress.address}
              onChange={(e) => {
                setcompanyAddress((prevData) => ({
                  ...prevData,
                  address: e.target.value,
                }));
              }}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row-reverse",
            padding: "28px 0px 22px 122px",
            marginTop: "10px",
            gap: "20px",
          }}
        >
          <Button
            text={"Update"}
            isDisabled={
              !companyAddress?.state?.value ||
              !companyAddress?.city?.value ||
               !companyAddress?.country?.value ||
              !companyAddress?.address
            }
            onClick={() => {
              updateCompanyInfo(
                companyAddress?.address,
                companyAddress?.country?.label,
                companyAddress?.state?.label,
                companyAddress?.city?.label
              );
            }}
            style={{ width: "90px", height: "35px", fontSize: "15px" }}
          />
          <Button
            text={"Cancel"}
            onClick={() => {
              onClose();
            }}
            style={{
              width: "90px",
              height: "35px",
              backgroundColor: "transparent",
              border: "1px solid rgba(191, 200, 217, 1)",
              fontSize: "15px",
              color: "rgba(96, 101, 113, 1)",
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default EditCompanyAdd;
